namespace Roodik.Game
{
	import ViewBase = Roodik.Core.ViewBase;
	import ISoundManager = Roodik.Core.ISoundManager;
	
	export class BoardView extends ViewBase
	{
		private _tilesView:Array<TileView>;
		
		constructor(private _model:BoardModel,
		            private _withTimer:boolean,
		            private _onOverCallBack:(tile:ITileModel)=>void,
		            private _onOutCallBack:(tile:ITileModel)=>void,
		            private _onSelectedCallBack:(tile:ITileModel)=>void,
		            private _tilesMatched:()=>void,
		            private _wrongMatch:()=>void,
		            private _awardsModel:AwardsModel,
		            private _soundManager:ISoundManager)
		{
			super();
			
			this.createBoard();
		}
		
		private createBoard()
		{
			this._tilesView = new Array<TileView>();
			let tilesModels = this._model.getTilesModels();
			for(let i = 0; i < tilesModels.length; i++)
			{
				this.createTile(i, tilesModels[i]);
			}

			this._model.matchCallBack(this.match.bind(this));
			this._model.incorrectMatchCallBack(this.wrongMatch.bind(this));
		}

		public showTiles()
		{
			this._soundManager.playSound("chain_get_starts.mp3", 0.5);

			for(let i = 0; i < this._tilesView.length; i++)
			{
				this._tilesView[i].show();
			}
		}
		
		private wrongMatch()
		{
			this._wrongMatch();
		}

		private match()
		{
			var tilesForRemove = this._model.cachedTilesForRemove;
			if(tilesForRemove.length != 0)
			{
				this._model.removeTiles(()=>{
					for(var i : number = 0; i < tilesForRemove.length; i++)
					{
						this._tilesView[tilesForRemove[i].index].remove();
					}
				});
				this._tilesMatched();

				let scoreAnimation = new ScoreAnimationView(this._awardsModel.addedScore, ()=>{
					scoreAnimation.destroy();
					this.removeChild(scoreAnimation);
				});
				scoreAnimation.x = tilesForRemove[tilesForRemove.length-1].x;
				scoreAnimation.y = tilesForRemove[tilesForRemove.length-1].y;
				this.addChild(scoreAnimation);
			}
		}
		
		private createTile(index:number, model:ITileModel)
		{
			let tileView = new TileView(index, model, (selectedIndex : number) =>
			{
				let selected = this._model.selectTile(selectedIndex);
				if (selected)
				{
					this._onSelectedCallBack(this._model.selectedTile);
				}
			}, (tile:ITileModel)=>{
				this._onOverCallBack(tile);
			},
			(tile:ITileModel)=>{
				this._onOutCallBack(tile);
			});
			this.addChild(tileView);
			this._tilesView[index] = tileView;
		}

		public selectedTile():ITileModel {return this._model.selectedTile;}

		public destroy()
		{
			for(let i = 0; i < this._tilesView.length; i++)
			{
				this._tilesView[i].destroy();
			}
			this._tilesView = null;

			this._model.destroy();

			this._model = null;
			this._onOverCallBack = null;
			this._onOutCallBack = null;
			this._onSelectedCallBack = null;
			this._tilesMatched = null;

			super.destroy();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/Board/BoardView.ts